<template>
  <DialogBox v-if="isShow" show :w="470">
    <div class="clearfix" style="padding:20px;">
      <div style="height:22px;">
        <strong style="font-size:16px;">
          <span v-if="config.type=='remove'">{{ config.title||'删除对话框' }}</span>
          <span v-else>{{ config.title||'确认对话框' }}</span>
        </strong>
      </div>
      <div style="color:#666;height:100px;margin-top:20px;" v-html="config.text"></div>
      <div class="float-right">
        <el-button @click="ok" v-if="config.type=='remove'" type="danger" style="background:#f63;" size="medium">确定</el-button>
        <el-button @click="ok" v-else type="primary" size="medium">确定</el-button>
        <el-button @click="cancel" size="medium">取消</el-button>
      </div>
    </div>
  </DialogBox>
</template>

<script>
import DialogBox from "@components/DialogBox.vue";

export default {
  components: {
    DialogBox
  },
  data() {
    return {
      isShow: false,
      config: {
        type: "",
        title: "",
        text: ""
      }
    };
  },
  created() {
    window.$alert = this.show;
    //   $alert({
    //     type: "remove",
    //     title: "确定解绑吗？",
    //     text: "一旦解绑微信将无法收到通知，请确定是否继续。",
    //     ok: () => this.getData(),
    //     cancel: () => this.getData()
    //   });
  },
  methods: {
    show(config) {
      this.config = config || {};
      this.isShow = true;
    },
    ok() {
      this.isShow = false;
      if (this.isFunc(this.config.ok)) this.config.ok();
    },
    cancel() {
      this.isShow = false;
      if (this.isFunc(this.config.cancel)) this.config.cancel();
    },
    isFunc(args) {
      return Object.prototype.toString.call(args) === "[object Function]";
    }
  }
};
</script>